import { createAction } from '@reduxjs/toolkit';

import * as actionTypes from './actionTypes';

export const deleteFile = createAction<any>(actionTypes.DELETE_FILE.BASE);
